import JoinNowServices from './JoinNowServices';
import JoinNowServicesMock from './JoinNowServicesMock';

let isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
// process.env.VUE_APP_SERVICES === 'enabled' check is for ChangeCover to use mock APIs when running locally with mock data, because it uses the Eligibility step from public website.
if (process.env.VUE_APP_SERVICES && process.env.VUE_APP_SERVICES === 'enabled') {
  isMockingService = false;
}
export default isMockingService ? JoinNowServicesMock : JoinNowServices;
